import { FC, memo, PropsWithChildren } from 'react';

import {
  Evaluatable,
  WorkflowDataResolverDependencies,
} from '~/core/shared/types';
import { DisplayWhen } from './DisplayWhen';

type OptionallyDisplayWhenProps = PropsWithChildren<{
  evaluatable?: Evaluatable;
  workflowDataResolverDependencies?: Partial<WorkflowDataResolverDependencies>;
}>;

const OptionallyDisplayWhenComponent: FC<OptionallyDisplayWhenProps> = ({
  evaluatable,
  workflowDataResolverDependencies,
  children,
}) => {
  if (!evaluatable || !workflowDataResolverDependencies) {
    return <>{children}</>;
  }

  return (
    <DisplayWhen
      evaluatable={evaluatable}
      workflowDataResolverDependencies={workflowDataResolverDependencies}
    >
      {children}
    </DisplayWhen>
  );
};

export const OptionallyDisplayWhen = memo(OptionallyDisplayWhenComponent);
